// extracted by mini-css-extract-plugin
export default {"Feed__Wrapper":"Feed_Feed__Wrapper__AW73v","Posts__Container":"Feed_Posts__Container__YzPQ4"};